<!-- skeleton-table.component.html -->
<div class="skeleton-table-container">
  <table>
    <thead>
      <tr>
        @if (isFullWidthHeader) {
          <th [attr.colspan]="columns.length">
            <ngx-skeleton-loader
              [animation]="'progress-dark'"
              [theme]="{
                'border-radius': '5px',
                'background-color': 'var(--gray-dark-2)',
                height: '100%',
                'animation-duration': '2s'
              }"></ngx-skeleton-loader>
          </th>
        } @else {
          @for (item of columns; track $index) {
            <th>
              <ngx-skeleton-loader
                [animation]="'progress-dark'"
                [theme]="{
                  'border-radius': '5px',
                  'background-color': 'var(--gray-dark-2)',
                  height: '100%',
                  'animation-duration': '2s'
                }"></ngx-skeleton-loader>
            </th>
          }
        }
      </tr>
    </thead>
    <tbody>
      @for (item of rows; track $index) {
        <tr>
          @if (isFullWidthBody) {
            <th [attr.colspan]="columns.length">
              <ngx-skeleton-loader
                [animation]="'progress-dark'"
                [theme]="{
                  'border-radius': '5px',
                  'background-color': 'var(--gray-dark-3)',
                  'animation-duration': '2s',
                  height: '100%'
                }"></ngx-skeleton-loader>
            </th>
          } @else {
            @for (item of columns; track $index) {
              <td>
                <ngx-skeleton-loader
                  [animation]="'progress-dark'"
                  [theme]="{
                    'border-radius': '5px',
                    'background-color': 'var(--gray-dark-3)',
                    'animation-duration': '2s',
                    height: '100%'
                  }"></ngx-skeleton-loader>
              </td>
            }
          }
        </tr>
      }
    </tbody>
    <tfoot>
      <tr>
        @if (isFullWidthFooter) {
          <th [attr.colspan]="columns.length">
            <ngx-skeleton-loader
              [animation]="'progress-dark'"
              [theme]="{
                'border-radius': '5px',
                'background-color': 'var(--gray-dark-2)',
                height: '100%',
                'animation-duration': '2s'
              }"></ngx-skeleton-loader>
          </th>
        } @else {
          @for (item of columns; track $index) {
            <th>
              <ngx-skeleton-loader
                [animation]="'progress-dark'"
                [theme]="{
                  'border-radius': '5px',
                  'background-color': 'var(--gray-dark-2)',
                  height: '100%',
                  'animation-duration': '2s'
                }"></ngx-skeleton-loader>
            </th>
          }
        }
      </tr>
    </tfoot>
  </table>
</div>
